//
//
//
//
//
//
//
//
//
//


import QueryFilter from './QueryFilter';

export default {
    name: "AppSorting",
    data() {
        return {
            sortOptions: [
                { id: null, display: 'Relevance'},
                { id: 'Published desc', display: 'Recent'}
            ]
        }
    },
    methods: {
        setOrderBy: function(event) {
            if(event && event.target)
                this.$store.dispatch('changeOrdering', event.target.value);
        }
    }
};
